module.exports = function getResource(label) {
    const resources = {
        itemsInOrder: 'Items in order',
        itemInOrder: 'Item in order',
        viewBasket: 'View basket'
    };

    return resources[label];
};
